import { connect } from 'react-redux';
import SchoolEnrollAgeView from './SchoolEnrollAgeView';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_EDUCATION_GOAL_API } from '../ChildrenInfoWorkflowConstants';
import * as childrenSelector from '../ChildrenInfoWorkflowSelector';

const mapStateToProps = (state, ownProps) => {
  const clientId = childrenSelector.clientId(state, ownProps);
  const childFirstName = childrenSelector.getSelectedChildFirstName(state, ownProps);

  const educationGoalList = childrenSelector.getEducationGoalList(state, ownProps);
  const childEducationGoal = childrenSelector.getChildEducationGoal(
    educationGoalList,
    childFirstName,
  );
  const isEditingGoal = !!childEducationGoal.Id;

  const inputEnrollAge = childrenSelector.getInputEnrollAge(state, ownProps);

  const existingEnrollAge = childEducationGoal.Age;

  const hasYearsChanged =
    (!inputEnrollAge && inputEnrollAge === '') || (inputEnrollAge && inputEnrollAge.length > 0);
  const childEnrollAge = hasYearsChanged ? inputEnrollAge : existingEnrollAge;

  const updatedEducationGoalData = childrenSelector.getUpdatedEducationGoalData(state, ownProps);

  const educationGoal = {
    ...childEducationGoal,
    ...updatedEducationGoalData,
    Name: childFirstName,
    ClientId: clientId,
    Age: childEnrollAge,
    IsStarted: false,
    Id: isEditingGoal ? childEducationGoal.Id : '',
  };

  return {
    clientId,
    childFirstName,
    childEnrollAge,
    educationGoal,
    isEditingGoal,
  };
};

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess: (data, educationGoal) => ({
    [BACKEND_EDUCATION_GOAL_API]: educationGoal,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SchoolEnrollAgeView);
